"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThankYouPage = void 0;
const react_1 = __importStar(require("react"));
const config_1 = __importDefault(require("next/config"));
const router_1 = require("next/dist/client/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const components_1 = require("@amzn/monera-app-core-components/lib/components");
const static_component_1 = require("@amzn/monera-app-core-components/lib/components/static-component");
const gql_1 = require("@amzn/monera-app-core/lib/gql");
const models_1 = require("@amzn/monera-app-core/lib/models");
const error_1 = require("@amzn/monera-app-core/lib/models/error");
const registry_1 = require("@amzn/monera-app-core/lib/state/registry");
const stores_1 = require("@amzn/monera-app-core/lib/state/stores");
const config_2 = require("@amzn/monera-app-core/lib/utils/config");
const error_2 = require("@amzn/monera-app-core/lib/utils/error");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const shopping_portal_1 = require("@amzn/monera-app-core/lib/utils/shopping-portal");
const headers_1 = require("../utils/headers");
const helpers_1 = require("../utils/helpers");
const _error_1 = require("./_error");
const createThankYouPage = (props) => {
    const { tenantTheme, componentsMap } = props;
    const ThankYouPage = (props) => {
        var _a, _b, _c, _d;
        const { error } = props;
        const [configStoreState] = (0, stores_1.useConfigStore)();
        const [shoppingPortalState] = (0, stores_1.useShoppingPortalStore)();
        const layout = configStoreState.layout;
        const requestId = configStoreState.requestId;
        const tenant = configStoreState.tenant;
        const countryCode = configStoreState.countryCode;
        const router = (0, router_1.useRouter)();
        const { moneraTools } = router.query;
        const isAipsRedirect = ((_a = router.query.isAipsRedirect) !== null && _a !== void 0 ? _a : '');
        const aipsStatus = ((_b = router.query.status) !== null && _b !== void 0 ? _b : '');
        const adgwdg = (_c = configStoreState.routing) === null || _c === void 0 ? void 0 : _c.adgwdg;
        monera_app_core_1.serverConsole.log(`Rendering ThankYouPage for adgwdg: ${adgwdg}, country: ${countryCode}`);
        (0, react_1.useEffect)(() => {
            if ((0, monera_app_core_1.isClientSide)()) {
                (0, config_2.initClientsideConfig)(configStoreState, shoppingPortalState.deviceType);
                monera_app_core_1.csm.emitPlatformTag();
                monera_app_core_1.csm.emitTenantStandardTag();
            }
        }, []);
        (0, react_1.useEffect)(() => {
            const statusCode = window.moneraStatusCode;
            const tenant = window.moneraTenant;
            if (statusCode) {
                (0, metric_helper_1.meterStatusCode)({ statusCode, tenant, methodName: 'ThankYouPage', requestId: configStoreState.requestId });
            }
        });
        (0, react_1.useEffect)(() => {
            const methodName = 'GetThankYouPage';
            const metricName = 'PageCount:ThankYouPage';
            const value = 1;
            (0, metric_helper_1.emitCountMetrics)(methodName, metricName, value, requestId, tenant);
        }, []);
        if (error) {
            return react_1.default.createElement(_error_1.ErrorPage, { error: error, statusCode: (_d = error.statusCode) !== null && _d !== void 0 ? _d : 500 });
        }
        if (isAipsRedirect && aipsStatus !== 'SUCCESS' && aipsStatus !== 'PENDING') {
            return (react_1.default.createElement(_error_1.ErrorPage, { error: {
                    name: models_1.ErrorType.MULTI_FACTOR_PAYMENT_AUTHENTICATION_EXCEPTION,
                    message: `Aips status was ${aipsStatus}`
                }, statusCode: 400 }));
        }
        return (react_1.default.createElement(components_1.PageWrapper, { pageType: models_1.PageType.ThankYouPage, deviceType: shoppingPortalState.deviceType || monera_app_core_1.DeviceType.Desktop, tenant: tenant, tenantTheme: tenantTheme, componentsMap: componentsMap },
            moneraTools === 'true' && react_1.default.createElement(components_1.Rerenderer, { "aria-label": "Rerender Button", copy: "+" }),
            react_1.default.createElement(components_1.CoreFonts, null),
            react_1.default.createElement(static_component_1.StaticComponent, Object.assign({}, layout))));
    };
    ThankYouPage.getInitialProps = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const { res, req, query } = ctx;
        const isAipsRedirect = ((_a = query.isAipsRedirect) !== null && _a !== void 0 ? _a : '');
        const aipsStatus = ((_b = query.status) !== null && _b !== void 0 ? _b : '');
        const orderId = query.orderId ? query.orderId : null;
        const asin = query.asin ? query.asin : null;
        const getThankYouPage = 'GetThankYouPage';
        const requestId = req.id;
        const configStoreActions = registry_1.registry.getStore(monera_app_core_1.configStore, requestId).getActions();
        (0, config_2.persistConfigState)({ query, configStoreActions, url: req === null || req === void 0 ? void 0 : req.url, incomingHeaders: req === null || req === void 0 ? void 0 : req.headers });
        const shoppingPortalState = registry_1.registry.getStore(stores_1.shoppingPortalStore, requestId).getState();
        configStoreActions.update({ pageType: models_1.PageType.ThankYouPage });
        let deviceType = (0, shopping_portal_1.getDeviceType)(shoppingPortalState.deviceAttributes);
        const customerId = shoppingPortalState.customerId;
        if (deviceType === null) {
            monera_app_core_1.serverConsole.error(`Invalid DeviceAttributes: "${shoppingPortalState.deviceAttributes}". Falling back to DESKTOP`);
            (0, metric_helper_1.meterFatals)({ methodName: 'DetailPage', metricName: 'GetDeviceType', error: true, requestId });
            deviceType = monera_app_core_1.DeviceType.Desktop;
        }
        else {
            (0, metric_helper_1.meterFatals)({ methodName: 'DetailPage', metricName: 'GetDeviceType', success: true, requestId });
        }
        if (isAipsRedirect && aipsStatus.toLowerCase() !== 'success' && aipsStatus.toLowerCase() !== 'pending') {
            const errorStatusCode = (0, models_1.getStatusCodeFromErrorType)(models_1.ErrorType.PAYMENT_INSTRUMENT_ERROR);
            if (res) {
                res.statusCode = errorStatusCode;
            }
            const errorResponse = {
                name: models_1.ErrorType.PAYMENT_INSTRUMENT_ERROR,
                message: 'AIPS Redirect, but AIPS status is not Success or Pending',
                statusCode: errorStatusCode
            };
            const error = Object.assign(Object.assign({}, errorResponse), { errorStatusCode });
            const segment = req === null || req === void 0 ? void 0 : req.segment;
            segment && (0, error_2.addErrorToXray)(segment, error);
            (0, metric_helper_1.meterFatals)({
                methodName: 'ThankYouPage',
                metricName: getThankYouPage,
                error: true,
                fault: false,
                requestId
            });
            return {
                error
            };
        }
        const cookie = req === null || req === void 0 ? void 0 : req.headers.cookie;
        const internalIpClass = shoppingPortalState.internalIpClass;
        const slateToken = shoppingPortalState.slateToken;
        const mShopCookie = 'amzn-app-ctxt';
        if ((0, shopping_portal_1.isValidCookie)(mShopCookie, cookie) && deviceType == monera_app_core_1.DeviceType.Tablet) {
            deviceType = monera_app_core_1.DeviceType.Mobile;
        }
        const { tenantIdOverride } = query;
        const startTime = Date.now();
        const headers = Object.assign({ [monera_app_core_1.ShoppingPortalHeadersEnum.UBID]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.ShoppingPortalHeadersEnum.UBID], [monera_app_core_1.ShoppingPortalHeadersEnum.SessionId]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.ShoppingPortalHeadersEnum.SessionId], [monera_app_core_1.ShoppingPortalHeadersEnum.AuthToken]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.ShoppingPortalHeadersEnum.AuthToken], [monera_app_core_1.ShoppingPortalHeadersEnum.TransitiveAuthToken]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.ShoppingPortalHeadersEnum.TransitiveAuthToken], [monera_app_core_1.ShoppingPortalHeadersEnum.Cookie]: req === null || req === void 0 ? void 0 : req.headers.cookie, [monera_app_core_1.HTTPHeaders.XForwardedFor]: shoppingPortalState.forwardedFor, [monera_app_core_1.ShoppingPortalHeadersEnum.InternalIpClass]: internalIpClass, [monera_app_core_1.ShoppingPortalHeadersEnum.RequestId]: requestId, [models_1.OverrideHeaderEnums.TenantIdOverride]: tenantIdOverride, [monera_app_core_1.ShoppingPortalHeadersEnum.SlateToken]: slateToken, [monera_app_core_1.ShoppingPortalHeadersEnum.DeviceAttributes]: shoppingPortalState.deviceAttributes, [monera_app_core_1.ShoppingPortalHeadersEnum.I18nPreferences]: shoppingPortalState.i18nPreferences, [monera_app_core_1.HTTPHeaders.XForwardedProto]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.HTTPHeaders.XForwardedProto] }, (0, shopping_portal_1.getWeblabOverrideHeader)(req));
        if ((_c = req === null || req === void 0 ? void 0 : req.headers) === null || _c === void 0 ? void 0 : _c.referer) {
            headers[monera_app_core_1.HTTPHeaders.Referer] = (_d = req === null || req === void 0 ? void 0 : req.headers) === null || _d === void 0 ? void 0 : _d.referer;
        }
        (0, headers_1.addHeader)(headers, monera_app_core_1.HTTPHeaders.UserAgent, req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.HTTPHeaders.UserAgent]);
        const response = yield (0, gql_1.queryMoneraService)({
            gqlQuery: gql_1.getThankYouPageGqlQuery,
            variables: {
                asin,
                orderId,
                deviceType,
                platformType: (0, shopping_portal_1.getPlatformType)(shoppingPortalState.deviceAttributes),
                marketplaceId: shoppingPortalState.marketplaceId,
                locale: shoppingPortalState.locale,
                pageType: models_1.PageType.ThankYouPage,
                customerId
            },
            headers
        });
        const moneraServiceResponseTime = Date.now() - startTime;
        const methodName = 'GetThankYouPage';
        const redirectMetricName = 'RedirectCount:ThankYouPage';
        if ((0, error_1.isRedirect)(response)) {
            (0, error_1.doRedirect)(response, req, res);
            const value = 1;
            (0, metric_helper_1.emitCountMetrics)(methodName, redirectMetricName, value, requestId, (0, config_2.retrieveConfigState)(headers).tenantId);
            return {};
        }
        if ((0, error_1.isRedirectToSignInPage)(response)) {
            try {
                if (res) {
                    const { tenantId, moneraAppOriginalUri, moneraAppQuery } = (0, config_2.retrieveConfigState)(headers);
                    const protocol = (_e = headers[monera_app_core_1.HTTPHeaders.XForwardedProto]) !== null && _e !== void 0 ? _e : 'https';
                    const amazonUrl = `${protocol}://${shoppingPortalState.forwardedHost}`;
                    let currentUrl = `${amazonUrl}${moneraAppOriginalUri}`;
                    if (moneraAppQuery) {
                        currentUrl += `?${moneraAppQuery}`;
                    }
                    monera_app_core_1.serverConsole.log('originalUrl', req === null || req === void 0 ? void 0 : req.url, 'baseUrl', amazonUrl, 'host', req === null || req === void 0 ? void 0 : req.headers.host);
                    const redirectUrl = (0, monera_app_core_1.getAuthPortalUrlV2)(amazonUrl, (0, helpers_1.getCountryCodeFromOriginHelper)(shoppingPortalState.forwardedHost), undefined, tenantId, currentUrl);
                    monera_app_core_1.serverConsole.log(`Routing to ${redirectUrl}`);
                    (0, metric_helper_1.emitCountMetrics)(methodName, redirectMetricName, 1, requestId, (0, config_2.retrieveConfigState)(headers).tenantId);
                    res
                        .writeHead(302, {
                        Location: redirectUrl,
                        'x-amazon-internal-redirect': '1',
                        'x-amazon-redirect-ignore-cookie': '1'
                    })
                        .end();
                    return {};
                }
                else {
                    throw new Error(`Unexpected error while handleRedirectToSignInPage, missing NextJs ServerResponse`);
                }
            }
            catch (error) {
                monera_app_core_1.serverConsole.warn(error);
            }
        }
        if ((0, models_1.isError)(response)) {
            const statusCode = (0, models_1.getStatusCodeFromErrorType)(response.name);
            if (res) {
                res.statusCode = statusCode;
            }
            const statusCodePrefix = statusCode.toString().charAt(0);
            if (res) {
                res.statusCode = statusCode;
            }
            const error = Object.assign(Object.assign({}, response), { statusCode });
            const segment = req === null || req === void 0 ? void 0 : req.segment;
            segment && (0, error_2.addErrorToXray)(segment, error);
            (0, metric_helper_1.meterFatals)({
                methodName: 'ThankYouPage',
                metricName: getThankYouPage,
                error: statusCodePrefix === '4',
                fault: statusCodePrefix === '5',
                requestId
            });
            return {
                error
            };
        }
        const tenant = response.data.page.tenant.toUpperCase();
        if (tenant) {
            configStoreActions.update({ tenant });
        }
        const countryCodeResp = response.data.page.countryCode;
        if (countryCodeResp) {
            const countryCode = countryCodeResp === 'GB' ? 'uk' : countryCodeResp.toLowerCase();
            configStoreActions.update({ countryCode });
        }
        (0, metric_helper_1.meterFatals)({
            methodName: 'ThankYouPage',
            metricName: getThankYouPage,
            tenant,
            success: true,
            requestId
        });
        (0, metric_helper_1.emitLatencyMetrics)('ThankYouPage', getThankYouPage, moneraServiceResponseTime, requestId, tenant);
        const config = (0, config_1.default)();
        let envShoppingPortal = monera_app_core_1.ENV_SHOPPING_PORTAL;
        if ((0, monera_app_core_1.isClientSide)() && config) {
            const { publicRuntimeConfig } = config;
            envShoppingPortal = publicRuntimeConfig.envShoppingPortal;
        }
        if (res && envShoppingPortal) {
            const spParams = (0, models_1.getBaseShoppingPortalParams)();
            spParams.pageType = 'MoneraThankYouPage';
            spParams.pageSubType = tenant;
            const shoppingPortalConfig = response.data.page.shoppingPortalConfig;
            if (shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navStoreName) {
                spParams.navStoreName = shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navStoreName;
            }
            if (shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navNodeId) {
                spParams.navNodeId = shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navNodeId;
            }
            (0, monera_app_core_1.writeShoppingPortalResponseHeaders)(res, spParams);
        }
        const layout = JSON.parse(response.data.page.componentDefinitionString);
        configStoreActions.update({ layout });
        return {};
    });
    return ThankYouPage;
};
exports.createThankYouPage = createThankYouPage;
